import { Trans } from '@lingui/react/macro';
import { Button } from 'src/components';

const surveyAnswers = {
  DONT_USE: <Trans>I don&apos;t use the features enough</Trans>,
  EXPENSIVE: <Trans>It&apos;s too expensive</Trans>,
  RETURN: <Trans>I am returning my reMarkable</Trans>,
  BOUGHT_FOR_OTHER: <Trans>I bought Connect for someone else</Trans>,
  SELLING: <Trans>I am selling my reMarkable</Trans>,
  TRANSFER_TO_CONNECT_FOR_BUSINESS: (
    <Trans>Transferring to Connect for Business</Trans>
  ),
  OTHER: <Trans>Other</Trans>,
};

export interface MrfSurveyProps {
  selectedAnswer: string | null;
  setSelectedAnswer: (answer: string) => void;
}

export const CancelConnectSurveyForm = ({
  selectedAnswer,
  setSelectedAnswer,
}: MrfSurveyProps) => {
  return (
    <div className="flex flex-col space-y-8">
      {Object.entries(surveyAnswers).map(([key, value]) => (
        <Button
          key={key}
          size="medium"
          onClick={() => setSelectedAnswer(key)}
          variant={selectedAnswer === key ? 'tertiary' : 'secondary'}
          className="w-full"
          data-cy={key}
        >
          {value}
        </Button>
      ))}
    </div>
  );
};
